import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

interface BoxInfoProps {
	$alignText: string;
}

export const boxInfo = styled.div<BoxInfoProps>`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: ${(props) => props.$alignText};
	justify-content: center;
	padding: 1rem;
`;

interface TypeTextProps {
	$weight: string;
	$size: number;
}

export const title = styled.p<TypeTextProps>`
	font-weight: ${(props) => props.$weight};
	font-size: ${(props) => props.$size}px;
	font-family: nunito-light;
`;

export const subTitle = styled.p<TypeTextProps>`
	font-weight: ${(props) => props.$weight};
	font-size: ${(props) => props.$size}px;
	font-family: nunito-light;
`;
